/**
 * @generated SignedSource<<ab69564356886b406400450e00440a44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ColorSchemeSync_query$data = {
  readonly colorScheme: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string;
      };
    }>;
  };
  readonly " $fragmentType": "ColorSchemeSync_query";
};
export type ColorSchemeSync_query$key = {
  readonly " $data"?: ColorSchemeSync_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"ColorSchemeSync_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ColorSchemeSync_query",
  "selections": [
    {
      "alias": "colorScheme",
      "args": [
        {
          "kind": "Literal",
          "name": "filterElement",
          "value": {
            "single": {
              "name": "name",
              "operator": "equals",
              "value": "color_scheme"
            }
          }
        }
      ],
      "concreteType": "UserDataConnection",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserDataEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserData",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"color_scheme\"}})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ca71cfdf94fc0310183b74c098fd1f68";

export default node;
